<template>
    <div class="choose-bar">
        <div class="nav-bar">
            <div 
                :class="`${activeId.includes(1)&&'active'} ${chooseId==1&&'choose-active'}`"
                @click="openChooseMenu(1)"
            >
                <span>{{chooseTips[0]}}</span>
                <img 
                    src="@/assets/hotel/img/search/arrow_bottom_active.png" 
                    alt="active" 
                    v-show="chooseId==1||activeId.includes(1)"
                >
                <img 
                    src="@/assets/hotel/img/search/arrow_bottom.png" 
                    alt="default"
                    v-show="chooseId!=1&&(!activeId.includes(1))"
                >
            </div>
            <div 
                :class="`${activeId.includes(2)&&'active'} ${chooseId==2&&'choose-active'}`"
                @click="openChooseMenu(2)"
            >
                <span>{{chooseTips[1]}}</span>
                <img 
                    src="@/assets/hotel/img/search/arrow_bottom_active.png" 
                    alt="active" 
                    v-show="chooseId==2||activeId.includes(2)"
                >
                <img 
                    src="@/assets/hotel/img/search/arrow_bottom.png" 
                    alt="default"
                    v-show="chooseId!=2&&(!activeId.includes(2))"
                >
            </div>
            <div 
                :class="`${activeId.includes(3)&&'active'} ${chooseId==3&&'choose-active'}`"
                @click="openChooseMenu(3)"
            >
                <span>{{chooseTips[2]}}</span>
                <img 
                    src="@/assets/hotel/img/search/arrow_bottom_active.png" 
                    alt="active" 
                    v-show="chooseId==3||activeId.includes(3)"
                >
                <img 
                    src="@/assets/hotel/img/search/arrow_bottom.png" 
                    alt="default"
                    v-show="chooseId!=3&&(!activeId.includes(3))"
                >
            </div>
            <div 
                :class="`${activeId.includes(4)&&'active'} ${chooseId==4&&'choose-active'}`"
                @click="openChooseMenu(4)"
            >
                <span>{{chooseTips[3]}}</span>
                <img 
                    src="@/assets/hotel/img/search/arrow_bottom_active.png" 
                    alt="active" 
                    v-show="chooseId==4||activeId.includes(4)"
                >
                <img 
                    src="@/assets/hotel/img/search/arrow_bottom.png" 
                    alt="default"
                    v-show="chooseId!=4&&(!activeId.includes(4))"
                >
            </div>
        </div>
        <!-- 遮罩 -->
        <div 
            class="pop-bg"
            @click="chooseId = 0"
            v-if="chooseId!=0"
        ></div>
        <div 
            class="pop-content"
            v-if="chooseId!=0"
        >
            <Sort 
                ref="sort"
                v-show="chooseId==1"></Sort>
            <Position 
                :setData="choosemenu.area"
                ref="position"
                v-show="chooseId==2"
            ></Position>
            <Price 
                ref="price"
                v-show="chooseId==3"></Price>
            <Filters 
                :setData="choosemenu.filter" 
                ref="filter"
                v-show="chooseId==4"
            ></Filters>
            <div class="choose-btn">
                <div 
                    class="btn reset"
                    @click="reset"
                >重置</div>
                <div 
                    class="btn confirm"
                    @click="confirm"
                >完成</div>
            </div>
        </div>
    </div>
</template>

<script>
import Sort from '@/pages/hotel/home/indexComponents/sort.vue'
import Position from '@/pages/hotel/home/indexComponents/position.vue'
import Price from '@/pages/hotel/home/indexComponents/price.vue'
import Filters from '@/pages/hotel/home/indexComponents/filter.vue'
import { getFilterData } from '@/pages/hotel/api'
import { mapState } from 'vuex'
    export default {
        components:{
            Sort,Position,Price,Filters
        },
        data() {
            return {
                activeId:[1],//激活样式
                chooseId:0,//选中样式
                chooseTips:['综合排序','位置区域','价格/星级','筛选'],//选择提示
                choosemenu:{area:[],filter:{}},//选择条件,
                filterData:{
                    city_code:1
                },//筛选参数
            }
        },
         computed:{
            ...mapState({
                searchCity:state => state.hotel.searchCity,
            }),
         },
        created() {
            getFilterData(this.searchCity.value.code ? this.searchCity.value.code : 1).then((res)=>{
                this.choosemenu = res;
            })
        },
        methods: {
            openChooseMenu(idx){//开启筛选项
                document.body.setAttribute('class','noscroll');
                if(this.chooseId == idx){
                    this.chooseId = 0;
                }else{
                    this.chooseId = idx;
                    setTimeout(()=>{
                        if(idx==2){
                            this.$refs.position.init();
                        }else if(idx==4){
                            this.$refs.filter.init();
                        }
                    },1)
                }
            },
            reset(){//重置
                this.$refs.sort.reset();
                this.chooseTips[0] = '综合排序'
                delete this.filterData.sort;

                this.$refs.position.reset();
                this.chooseTips[1] = '位置区域'
                delete this.filterData.area_latitude;
                delete this.filterData.area_longitude;

                this.$refs.price.reset();
                this.chooseTips[2] = '价格/星级'
                delete this.filterData.min_price;
                delete this.filterData.max_price;
                delete this.filterData.star;

                this.$refs.filter.reset();
                this.chooseTips[3] = '筛选'
                delete this.filterData.hotel_type;
                delete this.filterData.hotel_classify;
                delete this.filterData.facilities;

                this.activeId = [1];
                this.send();
            },
            confirm(){//确认
                let sort = this.$refs.sort.confirm();
                if(sort){
                    this.filterData.sort = sort.value;
                    this.chooseTips[0] = sort.name;
                }else{
                    delete this.filterData.sort;
                }
                
                let position = this.$refs.position.confirm();
                if(position&&position.name){
                    if(position.latitude){
                        this.filterData.area_latitude = position.latitude;
                        this.filterData.area_longitude = position.longitude;
                    }
                    this.chooseTips[1] = position.name;
                    if(!this.activeId.includes(2)){
                        this.activeId.push(2);
                    }
                }else{
                    this.chooseTips[1] = '位置区域';
                    delete this.filterData.area_latitude;
                    delete this.filterData.area_longitude;
                    let index = this.activeId.indexOf(2);
                    (index+1)&&this.activeId.splice(index,1);
                }

                let price = this.$refs.price.confirm();
                if(price&&(price[0]||price[2])){
                    this.filterData.min_price = price[0];
                    this.filterData.max_price = price[1];
                    this.filterData.star = price[2];
                    if(!this.activeId.includes(3)){
                        this.activeId.push(3);
                    }
                }else{
                    delete this.filterData.min_price;
                    delete this.filterData.max_price;
                    delete this.filterData.star;
                    let index = this.activeId.indexOf(3);
                    (index+1)&&this.activeId.splice(index,1);
                }

                let filters = this.$refs.filter.confirm();
                if(filters&&filters.value&&(filters.value[0].length||filters.value[1].length||filters.value[2].length)){
                    if(filters.value[0].length){
                        this.filterData.hotel_type = filters.value[0];
                    }
                    if(filters.value[1].length){
                        this.filterData.hotel_classify = filters.value[1];
                    }
                    if(filters.value[2].length){
                        this.filterData.facilities = filters.value[2];
                    }
                    this.chooseTips[3] = filters.name;
                    if(!this.activeId.includes(4)){
                        this.activeId.push(4);
                    }
                }else{
                    this.chooseTips[3] = '筛选';
                    delete this.filterData.hotel_type;
                    delete this.filterData.hotel_classify;
                    delete this.filterData.facilities;
                    let index = this.activeId.indexOf(4);
                    (index+1)&&this.activeId.splice(index,1);
                }
                this.chooseId = 0;
                this.send();
            },
            send(){
                this.$emit('send',{...this.filterData});
            }
        },
        watch:{
            chooseId(){
                if(this.chooseId == 0){
                    document.body.removeAttribute('class','noscroll');
                }
            },
            'searchCity.bool'(){
                if(this.searchCity.bool){
                    getFilterData(this.searchCity.value.code ? this.searchCity.value.code : 1).then((res)=>{
                        this.choosemenu = res;
                    })
                }
            }
        },
        beforeDestroy() {
            document.body.removeAttribute('class','noscroll');
        },
    }
</script>

<style lang="less" scoped>
    .choose-bar{
        .nav-bar{
            display: flex;
            justify-content: space-between;
            padding: 0 2rem;
            div{
                padding: 1rem 0;
                display: inline-flex;
                align-items: center;
                &.active{
                    span{
                        color: #108B30;
                    }
                }
                &.choose-active{
                    span{
                        color: #108B30;
                    }
                    img{
                        transform-origin: center;
                        transform:rotateZ(180deg);
                    }
                }
                span{
                    display: inline-block;
                    max-width: 6.7rem;
                    font-size: 1.5rem;
                    line-height: 2.1rem;
                    color: #999999;
                    margin-right: 0.2rem;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    text-align: right;
                }
                img{
                    width: 0.8rem;
                    height: 0.8rem;
                    transform: translateY(-0.1rem);
                } 
            }
        }
        .pop-bg{
            background-color: rgba(0,0,0,0.5);
            position: fixed;
            left: 0;
            right: 0;
            bottom: 0;
            top: 16rem;
            z-index: 10;
        }
        .pop-content{
            position: absolute;
            left: 0;
            right: 0;
            z-index: 20;
            background-color: #fff;
            .choose-btn{
                display: flex;
                justify-content: space-between;
                padding: 2rem 0;
                margin: 0 2rem;
                position: relative;
                &::after {
                    content: "";
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 0.1rem;
                    background-color: #DDDDDD;
                    -webkit-transform: scaleY(0.5);
                    transform: scaleY(0.5);
                }
                .btn{
                    width: 16rem;
                    height: 4rem;
                    border-radius: 2.25rem;
                    text-align: center;
                    line-height: 4rem;
                    font-size: 1.6rem;
                    color: #666666;
                }
                .reset{
                    position: relative;
                    &::after {
                        content: "";
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 200%;
                        height: 200%;
                        border: 0.1rem solid #333333;
                        border-radius: 5rem;
                        -webkit-transform-origin: 0 0;
                        -moz-transform-origin: 0 0;
                        -ms-transform-origin: 0 0;
                        -o-transform-origin: 0 0;
                        transform-origin: 0 0;
                        -webkit-transform: scale(0.5, 0.5);
                        -ms-transform: scale(0.5, 0.5);
                        -o-transform: scale(0.5, 0.5);
                        transform: scale(0.5, 0.5);
                        -webkit-box-sizing: border-box;
                        -moz-box-sizing: border-box;
                        box-sizing: border-box;
                    }
                }
                .confirm{
                    background: linear-gradient(90deg,#0FBF6D 0%,#108B30 100%);
                    color: #fff;
                }
            }
        }
    }
</style>